// @flow
import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';

import * as layoutConstants from '../constants/layout';
import Loading from './Loading';

// Lazy loading and code splitting
const AuthLayout = React.lazy(() => import('../layouts/Auth'));
const HorizontalLayout = React.lazy(() => import('../layouts/Horizontal'));

/**
 * Exports the component with layout wrapped to it
 * @param {} WrappedComponent
 */
const withLayout = (WrappedComponent: any) => {
    type HOCProps = {
        layout: { layoutType?: string },
    };
    const HOC = class extends Component<HOCProps> {
        /**
         * Returns the layout component based on different properties
         */
        getLayout = () => {
            if (!this.props.app.connected) return AuthLayout;

            return HorizontalLayout;
        };

        render() {
            const Layout = this.getLayout();
            return (
                <Suspense fallback={<Loading />}>
                    <Layout {...this.props}>
                        <WrappedComponent {...this.props} />
                    </Layout>
                </Suspense>
            );
        }
    };

    const mapStateToProps = state => {
        return {
            layout: state.Layout,
            app: state.App
        };
    };

    return connect(
        mapStateToProps,
        null
    )(HOC);
};

export default withLayout;
